// src/App.js

// ������ ������� �������� React
import React, { useState } from 'react';
// ������ ���������� ��� �������������: Router, Routes, Route
// BrowserRouter (�������������� �� Router) ��������� ������������� ����� URL ��������.
// Routes ��'���� ���������� ��������.
// Route ������� ������� ������� � ��������� �����������.
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// ������ ���������� �������, �� ���������������� � �������������
import AboutPage from './pages/AboutPage';
import ContactsPage from './pages/ContactsPage';
import ServicesPage from './pages/ServicesPage';
import ProjectsPage from './pages/ProjectsPage';
import AdminPage from './pages/AdminPage';
// ������ ���������� CSS ����� ��� ������ �������
import './styles/globals.css';

// ������ ���������� ������ (����� �� ������), �� ���������������� �� �������� �������
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// ������ ���������� ������, �� ��������� ������� �������
import Hero from './components/sections/Hero';
import AboutUs from './components/sections/AboutUs';
import WhyUs from './components/sections/WhyUs';
import Services from './components/sections/Services';
import Testimonials from './components/sections/Testimonials';
import ContactForm from './components/sections/ContactForm';

// ������ ���������� ����� ��� ������
import AdminLogin from './components/shared/AdminLogin';

/**
 * ��������� HomePage.
 * ����� �� ������ ��� ����������� ������� ������� �����.
 * @returns {JSX.Element} JSX-������� ������� �������.
 */
const HomePage = () => {
    return (
        <>
            {/* ����������, �� �������� ��������� ������� ������� */}
            <Header />
            <Hero />
            <AboutUs />
            <WhyUs />
            <Services />
            <Testimonials />
            <ContactForm />
            <Footer />
        </>
    );
};

/**
 * �������� ��������� �������.
 * ��������� �������������, ����������, ���� ��������� �������
 * ���� ������������ ������� �� URL.
 * @returns {JSX.Element} JSX-������� ���������� ���������� �������.
 */
function App() {
    const [isAdmin, setIsAdmin] = useState(false); // ���� ����������� �������������

    return (
        // ��������� ���� ������� � Router ��� ��������� �������������
        <Router>
            {/* Routes - �� ��������� ��� ��� ���������� �������� */}
            <Routes>
                {/* ���������� �������� ��� ���������� ����� ("/") - �� ���� HomePage */}
                <Route path="/" element={<HomePage />} />
                {/* �������� ��� ����� ������� ������� */}
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/contacts" element={<ContactsPage />} />
                {/* ����� ��� ����� � ������: ���� ������������ � AdminPage, ������ � AdminLogin */}
                <Route
                    path="/admin"
                    element={
                        isAdmin ? (
                            <AdminPage />
                        ) : (
                            <AdminLogin onLogin={() => setIsAdmin(true)} />
                        )
                    }
                />
            </Routes>
        </Router>
    );
}

// ������� ���������� App �� ������������� ��� ������������ � ����� ����� ������� (���������, index.js)
export default App;
